import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
@Component({
    selector: 'app-color-dialog',
    templateUrl: './color-dialog.component.html',
    styleUrls: ['./color-dialog.component.scss'],
    standalone: false
})
export class ColorDialogComponent implements OnInit {
  color: any = '';
  public componentForm!: UntypedFormGroup;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ColorDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.componentForm = new UntypedFormGroup({
      color: new UntypedFormControl('', Validators.required),
    });
  }

  save(){
    this.touchFormControls();
    if (this.componentForm.invalid) {
      return;
    }
    this.dialogRef.close(this.componentForm.get('color')?.value); 
  }

  onColorChange(newColor: any) {
    this.componentForm.get('color')?.setValue(newColor);
    this.componentForm.get('color')?.markAsTouched();
  }

  close(data: any = null  ){
    this.dialogRef.close(data);
  }

  touchFormControls() {
    Object.keys(this.componentForm.controls).forEach((key) => {
      this.componentForm.get(key)?.markAsTouched();
    });
  }

}
